import { toApiDate } from '@/utils/formatters'
import type { ReportFilters } from '@/modules/reportTemplates/api'

export function staffReportFilters(filters: Record<string, unknown>): ReportFilters {
  const result: ReportFilters = {}
  for (const key of ['departments', 'positions', 'roles', 'status']) {
    const value = filters[key]
    if (Array.isArray(value) && value.length)
      result[key] = value.join(',')
  }
  for (const key of ['last_login_after', 'last_login_before']) {
    const value = filters[key]
    if (value instanceof Date || typeof value === 'string') {
      const date = toApiDate(value)
      if (date)
        result[key] = date
    }
  }
  if (typeof filters.search === 'string' && filters.search)
    result.search = filters.search
  return result
}
